export const reactSelectFilterCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    width: '100%',
    minHeight: 'calc(1.5em + 1.65rem + 2px)',
    height: 'calc(1.5em + 1.65rem + 2px)',
  }),
  menu: (provided, state) => ({
    ...provided,
    zIndex: 9999,
    maxHeight: `calc(100vh - 100px)`, // 100px de margem do topo
    overflowY: 'auto',
  }),
}
